import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env';
import { map } from 'rxjs/operators';
import { flattenObject } from '@utils/utils';
import { ResellerAgcomSubSenders, ResellerSubSenderAgcom } from '@models/reseller/sub-senders';

@Injectable({
  providedIn: 'root'
})
export class ResellerSendersService {
  private readonly baseUrl;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getAgcomListSubaccountSenders(
    all: boolean = false,
    page: number = null,
    size: number = null,
    type: string = null
  ): Observable<ResellerAgcomSubSenders> {
    let queryParams = new HttpParams().set('all', String(all));
    if (page) {
      queryParams = queryParams.set('page', String(page));
    }
    if (size) {
      queryParams = queryParams.set('size', String(size));
    }
    if (type) {
      queryParams = queryParams.set('numeric', type);
    }
    return this.http
      .get<Response>(this.baseUrl + 'sms/subaccount/agcom-sender', { params: queryParams })
      .pipe(map(data => ResellerAgcomSubSenders.deserialize(data)));
  }

  addAgcomResellSenderAlpha(sender: ResellerSubSenderAgcom): Observable<any> {
    const request = flattenObject(sender);
    (request as any).agcomTpoaAlias.tpoaUser.legalAgreement = true;
    return this.http.post(this.baseUrl + 'sms/subaccount/agcom-sender', request, {});
  }

  addAgcomResellerSenderNumeric(sender: ResellerSubSenderAgcom): Observable<any> {
    const request = {
      toAllSubaccounts: sender.toAllSubaccounts,
      idSubaccount: sender.idUser,
      agcomTpoaAlias: {
        sender: sender.sender,
        tpoaUser: {
          legalAgreement: true
        }
      }
    };
    return this.http.post(this.baseUrl + 'sms/subaccount/agcom-sender/', request, {});
  }

  confirmAgcomResellSender(sender: ResellerSubSenderAgcom, pin): Observable<any> {
    const request = {
      toAllSubaccounts: sender.toAllSubaccounts,
      idSubaccount: sender.idUser,
      agcomTpoaAlias: {
        sender: sender.sender,
        pin,
        tpoaUser: {
          legalAgreement: true
        }
      }
    };
    return this.http.post(this.baseUrl + 'sms/subaccount/agcom-sender/confirm', request, {});
  }

  removeAgcomResellerSender(sender: ResellerSubSenderAgcom) {
    const headers = new HttpHeaders().set('Content-type', 'application/json').set('Accept', 'application/json');
    return this.http.delete(this.baseUrl + 'sms/subaccount/agcom-sender/' + sender.idSender + '/subaccount/' + sender.idUser, { headers });
  }
}
